module.exports = __webpack_public_path__ + "assets/1@2x.01a995e9.png";